export const USER_ROLE = {
    DOCTOR: 'DOCTOR',
    PATIENT: 'PATIENT',
};

export const USER_STATUS = {
    PENDING_VERIFICATION: 'PENDING_VERIFICATION',
    PENDING_LICENCE_VERIFICATION: 'PENDING_LICENCE_VERIFICATION',
    ACTIVE: 'ACTIVE',
}
